<template>
  <section>
    <div class="richtext">
      <h2><strong>The importance of Newdose chemical metering pump</strong></h2>
      <p>
        <strong><br /></strong>
      </p>
      <p>
        With the improvement of production process index and automation level,
        the metering pump works as the final actuator of chemical dosing and
        adding process as the safety and controllability of the chemical
        metering pump becomes more and more important. The chemical industry is
        always famous for its spermatic production process. Meanwhile, the
        centralized-distributed and intelligent computer control system is
        widely applied in the chemical industry, thus require the metering pump
        equipped with flexible control mode, can easily constitute a variety of
        control circuit and computer system, to realize more complex and precise
        process control.<br />
      </p>
      <p><br /></p>
      <p>
        NEWDOSE chemical dosing pumps can provide suitable products to dose
        chemical solutions in the chemical industry. The chemicals play a very
        important role to serve in our daily life. Meanwhile, most of them are
        very dangerous but valuable. So there are many cases to use dosing pumps
        to well treated with the chemicals. The accuracy of NEWDOSE pump could
        be ±1% so as to ensure precise metering requirements and safety.
      </p>
      <p><br /></p>
      <p style="text-align: center">
        <img
          src="/uploads/image/20201123/Chemical-processing.jpg"
          title="Chemical processing"
          alt="Chemical processing"
          width="884"
          height="546"
          border="0"
          vspace="0"
          style="width: 884px; height: 546px"
        />
      </p>
      <p><br /></p>
      <p>
        The material of NEWDOSE diaphragm is PTFE that is the best
        anti-corrosion plastic for transferring chemical liquids. To meet
        various chemical properties, Newdose chemistry diaphragm pump use PVC,
        PVDF, PTFE and SS316 material to produce the contact parts. The metering
        media is isolated with the driven parts completely so as to protect the
        safe dosing and no leaking.
      </p>
      <p><br /></p>
    </div>
  </section>
</template>
<script>
export default {
  title: "Chemical Processing",
}
</script>